// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"63137af8","977":"031a7168"}[chunkId] + ".chunk.js";
};